var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"full-height"},[_c('iframe',{attrs:{"src":"https://reports.lyndus.com.br","width":"100%","height":"100%","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }